import { WaybillIdView } from '../../../../models';

export class ShipmentWaybillForeignTradeLoad {
  public static readonly type = '[ShipmentForeignTrade] Load';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillForeignTradeSetInitialState {
  public static readonly type = '[ShipmentForeignTrade] Set Initial State';
}
